document.addEventListener('DOMContentLoaded', () => {
  // 機能: スケジュールテーブルの自動スクロール
  // 概要: ページロード時、横スクロール可能なテーブルを当日の列が中央に来るまで移動させる。

  // ターゲット要素のセレクタ定義
  const TABLE_SELECTOR = '.js-userSchedules';
  const CURRENT_SELECTOR = '.is-current';
  // 最後の固定列を、固定エリアの終端の目印として使う
  const LAST_STICKY_HEADER_SELECTOR = '.is-sticky-last';
  const SCROLL_CONTAINER_SELECTOR = '.table-responsive';
  const STARTED_STATUS = '.is-started';

  const scheduleTable = document.querySelector(TABLE_SELECTOR);

  if (scheduleTable) {
    const scrollContainer = scheduleTable.closest(SCROLL_CONTAINER_SELECTOR);

    if (scrollContainer) {
      // ページの描画が完全に安定してから位置を計算するために少し待つ
      setTimeout(() => {
        // 横スクロールの設定
        const currentHeader = scheduleTable.querySelector(CURRENT_SELECTOR);
        const lastStickyHeader = scheduleTable.querySelector(LAST_STICKY_HEADER_SELECTOR);

        if (currentHeader && lastStickyHeader) {
          // 1. 固定列（左側のスクロールしない列）全体の幅を計算
          const containerRect = scrollContainer.getBoundingClientRect();
          const lastStickyRect = lastStickyHeader.getBoundingClientRect();
          const totalStickyWidth = lastStickyRect.right - containerRect.left;

          // 2. スクロール可能領域（表示領域から固定列を除いた部分）の幅と中心位置を計算
          const scrollableAreaWidth = scrollContainer.clientWidth - totalStickyWidth;
          const scrollableAreaCenter = scrollableAreaWidth / 2;

          // 3. スクロール対象（今日の列）の左端の位置をテーブルの開始位置から取得
          const currentHeaderOffsetLeft = currentHeader.offsetLeft;

          // 4. 最終的なスクロール位置を算出
          // 「今日の列の左端位置」から「固定列の幅」と「スクロール可能領域の中心までの距離」を引くことで、
          // 今日の列の左端が、スクロール可能領域の中心に配置されるように調整する。
          const desiredScrollLeft = currentHeaderOffsetLeft - totalStickyWidth - scrollableAreaCenter;

          // 5. 計算した位置にスクロールを実行（0未満にはならないようにする）
          scrollContainer.scrollLeft = Math.max(0, desiredScrollLeft);
        }

        // 縦スクロールの設定
        // 1. 対象ステータスの取得
        // <span class="practice-status category-practices-item__status is-sm is-started">着手</span>
        // の1つ目を対象とする（1つ以上はない想定だが念の為、ない場合もある）
        const status = scheduleTable.querySelector(STARTED_STATUS);
        if (status) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const lastStickyRect = lastStickyHeader.getBoundingClientRect();

          // 2. 固定列の全体の高さを計算
          const totalStickyHeight = lastStickyRect.bottom - containerRect.top;

          // 3. スクロール可能領域
          const scrollableAreaHeight = scrollContainer.clientHeight - totalStickyHeight;
          const scrollableAreaHeightCenter = scrollableAreaHeight / 2;

          // 4. スクロール対象（着手中）の上端の位置をテーブルの開始位置から取得
          const statusOffsetTop = status.parentElement.parentElement.offsetTop;

          // 5. 最終的なスクロール位置を算出
          const desiredScrollTop = statusOffsetTop - totalStickyHeight - scrollableAreaHeightCenter;

          // 6. 計算した位置にスクロールを実行（0未満にはならないようにする）
          scrollContainer.scrollTop = Math.max(0, desiredScrollTop);
        }
      }, 100);
    }
  }
});